module.exports = __webpack_public_path__ + "static/img/img_ai_ar_01.cb29ba2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img_ai_ar_01.jpg
// module id = WEPU
// module chunks = 1